export default __webpack_public_path__ + "static/media/two.299c94b0.svg";